var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn mt-3",attrs:{"id":"report"}},[_c('h1',{staticClass:"text-uppercase font-weight-bold"},[_vm._v("Avances")])])}]

export { render, staticRenderFns }